<template lang="pug">
AppDialog.activities-location-no-activity-modal(
  :show="show"
  is-dismissable
  append-to-body
  @close="$emit('close')"
)
  button.close(
    type="button"
    aria-hidden="true"
    @click="$emit('close')"
  )
    i.hi.hi-close.hi-12
  img.mt-20(
    width="420"
    height="360"
    :src="noActivityImg"
    alt="locations no activity"
  )
  .title No locations have been tracked for this day
  .text-superlight Use one of our mobile apps to track time
  a.btn.btn-primary.btn-lg(@click.prevent="$emit('close')") Dismiss
</template>

<script>
import { IMAGE_NO_ACTIVITY } from '~/rails_assets';

export default {
  name: 'ActivitiesLocationNoDataDialog',
  props: {
    show: Boolean,
  },
  data: () => ({
    noActivityImg: IMAGE_NO_ACTIVITY,
  }),
};
</script>
